import DotLoader from '@/components/aural-ui/dot-loader'
import { Overlay } from '@/components/aural-ui/overlay'

export default function GlobalLoading() {
  return (
    <Overlay opacity="none" glass="none" noise="none">
      <DotLoader />
    </Overlay>
  )
}
